<template>
  <svg class="custom-donut-chart" ref="donutChart"></svg>
</template>

<script>
import { SIDEBAR_CALLAPSED } from '@/common/events.types';
import * as d3 from 'd3';

export default {
  name: 'DonutChart',
  props: {
    width: Number,
    height: Number,
    colors: Array,
    chartValue: Number,
    maxValue: Number
  },
  data () {
    return {
      numberOfLevels: 3
    }
  },
  mounted () {
    let context = this;
    this.initChart();

    window.addEventListener('resize', this.initChart);

    this.$eventHub.$on(SIDEBAR_CALLAPSED, () => {
      setTimeout(function() {
        context.initChart();
      }, 200);
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.initChart);
    this.$eventHub.$off();
  },
  methods: {
    initChart () {
      if(this.svg) {
        this.svg.selectAll("*").remove();
      }

      const margin = 40;

      let width = this.$refs.donutChart.parentElement.offsetWidth;

      if(window.innerWidth < 768) {
        width = width - 100;

        if(width > 400) {
          width = 400;
        }
      } else {
        if(width > 300) {
          width = 300;
        }
      }

      const height = width;
      
      let radius = Math.min(width, height) / 2;
      const alphabet = ['a', 'b', 'c', 'd', 'e', 'f'];
      const data = {};
      let chartValueReducer = this.chartValue;

      for(let i = 1; i <= this.numberOfLevels; i++) {
        if(this.chartValue > i * (this.maxValue / 3)) {
          data[alphabet[i - 1]] = this.maxValue / 3;
          chartValueReducer = chartValueReducer - (this.maxValue / 3);
        } else {
          data[alphabet[i - 1]] = chartValueReducer;
          chartValueReducer = 0;
        }
      }

      data[alphabet[this.numberOfLevels]] = this.maxValue - this.chartValue;

      this.svg = d3
        .select(this.$refs.donutChart)
        .attr("width", width)
        .attr("height", height)
        .append("g")
          .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      // set the color scale
      var color = d3.scaleOrdinal()
        .domain(data)
        .range(this.colors)

      // Compute the position of each group on the pie:
      var pie = d3.pie()
        .value(function(d) {
          return d.value; 
        })
        .sort(null);

      var dataReady = pie(d3.entries( data));

      // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
      this.svg
        .selectAll('whatever')
        .data(dataReady)
        .enter()
        .append('path')
        .attr('d', d3.arc()
          .innerRadius(radius - 15)         // This is the size of the donut hole
          .outerRadius(radius)
        )
        .attr('fill', function(d){ return(color(d.data.key)) })
        .attr("stroke", "#121214")
        .style("stroke-width", "2px")
        .style("opacity", 0.7)
    }
  },
  watch: {
    chartValue () {
      this.initChart();
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-donut-chart {
    display: block;
    margin: 0 auto;
  }
</style>
